export default {"src":"/_next/static/image/public/images/flags/flag_691.ad515973f961fdcf9cedbe74af7888e5.svg","height":16,"width":24};